import debounce from 'debounce-promise'

const timestampsDict = {}

const createAction = (shouldUpdateFrame = false) => (action) => (...param) => {
  return {
    ...action(...param),
    shouldUpdateFrame
  }
}

const getAction = (action, ...param) => typeof action === 'function'
  ? action(...param)
  : ({ type: action })

const debouncedSuccessAction = debounce(async ({ api, requestPayload, dispatch, optimisticBackupAction, successAction, meta }) => {
  const payload = await api(requestPayload)

  if (optimisticBackupAction) {
    dispatch({ ...getAction(optimisticBackupAction), payload })
  }

  if (timestampsDict[successAction] === meta.timestamp) {
    dispatch({ ...getAction(successAction), payload, meta })
    return { success: true, payload }
  }
}, 700)

export const asyncAction = ({
  api,
  getApi,
  requestAction,
  optimisticSuccessAction,
  optimisticBackupAction,
  successAction,
  failureAction,
  ...actionMeta
}) => (_requestPayload) => async (dispatch, getState) => {
  // dispatch requestAction
  dispatch({ ...getAction(requestAction) })

  // compute requestPayload
  const requestPayload = typeof _requestPayload === 'function' ? _requestPayload(getState) : _requestPayload

  const meta = {
    shouldHandleRaceCondition: true, // handle race condition by default
    timestamp: new Date(), // Used to handle race condition - Must be defined right before making api call
    ...actionMeta
  }

  // dispatch optimisticSuccessAction based on computed requestPayload
  if (optimisticSuccessAction) {
    timestampsDict[successAction] = meta.timestamp
    dispatch({ ...getAction(optimisticSuccessAction, requestPayload) })
  }

  // allow dynamic api based on state
  const _api = typeof getApi === 'function' ? getApi(getState) : api

  try {
    if (optimisticSuccessAction) {
      return {
        ...await debouncedSuccessAction({
          api: _api,
          requestPayload,
          dispatch,
          optimisticBackupAction,
          successAction,
          meta
        })
      }
    } else {
    // make api call & 'wait' for response
      const payload = await _api(requestPayload)
      dispatch({ ...getAction(successAction), payload, meta })
      return { success: true, payload }
    }
  } catch (_error) {
    const error = _error.error || _error
    dispatch({ ...getAction(failureAction), error, meta })
    return { success: false, error }
  }
}

export const withFrameUpdate = createAction(true)

export const createAsyncObject = (defaultValue = null) => ({ fetched: false, fetching: false, error: null, backupData: null, data: defaultValue })
